import { render } from "./BattlesBetElement.vue?vue&type=template&id=126c961a&scoped=true"
import script from "./BattlesBetElement.vue?vue&type=script&lang=js"
export * from "./BattlesBetElement.vue?vue&type=script&lang=js"

import "./BattlesBetElement.vue?vue&type=style&index=0&id=126c961a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-126c961a"]])

export default __exports__